
<template>
  <div class="bash-box function-box">
    <!-- <link rel="stylesheet" href="css\cloudApp.css" />  -->
    <p class="h1 h1-title">{{ indata.FirstTitle }}</p>
    <span class="line"></span>
    <ul class="function-ul" style="width: auto">
      <li
        style="margin-bottom: 0px"
        @mouseenter="changeActive(index)"
        :class="NowIndex == index ? 'active' : ''"
        v-for="(item, index) in indata.children"
        :key="index"
      >
        <p class="h2">{{ item.title1 }}</p>
        <p class="detail">{{ item.title2 }}</p>
      </li>
    </ul>
    <ul class="function-img-ul">
      <li
        :class="NowIndex == index ? 'active' : ''"
        v-for="(item, index) in indata.children"
        :key="index"
      >
        <img :src="item.image" />
      </li>
    </ul>
  </div>
</template>

<style scoped src="../../public/css/cloudApp.css">
/* @import "../../public/css/cloudApp.css"; */
</style>

<script>
export default {
  name: "Templates11",
  props: {
    indata: Array,
  },
  data() {
    return {
      NowIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>
